import ExcelJS from "exceljs/dist/exceljs.min.js";
import { ISO_CODES, formatCountryWithDDI } from "./countries";

// Gera e baixa o template de importação de listas de campanha, com o mesmo
// dropdown de país (DDI + ISO) que o template de Contacts já tem — reusa os
// mesmos helpers/lista ISO, nenhuma lógica nova de país aqui.
export const downloadContactListTemplate = async () => {
  const columns = ["nome", "numero", "e-mail", "pais"];
  const countryColumnLetter = String.fromCharCode(65 + columns.indexOf("pais"));

  const wb = new ExcelJS.Workbook();

  // "Contatos" tem que ser a PRIMEIRA aba do arquivo — o backend
  // (ImportContacts.ts) lê a planilha pegando a primeira aba do workbook,
  // então a aba oculta de códigos ISO precisa vir depois dela.
  const mainSheet = wb.addWorksheet("Contatos");
  mainSheet.addRow(columns);
  mainSheet.addRow(["Contato 6", "5585888889999", "contato6@test.tom.br", formatCountryWithDDI("BR")]);
  mainSheet.addRow(["Contato 12", "5585888889991", "", formatCountryWithDDI("BR")]);

  const isoSheet = wb.addWorksheet("PaisesISO", { state: "veryHidden" });
  ISO_CODES.forEach((code, idx) => {
    isoSheet.getCell(`A${idx + 1}`).value = formatCountryWithDDI(code);
  });

  mainSheet.dataValidations.add(`${countryColumnLetter}2:${countryColumnLetter}1000`, {
    type: "list",
    allowBlank: true,
    showErrorMessage: true,
    errorTitle: "Código inválido",
    error: "Selecione um código de país da lista.",
    formulae: [`PaisesISO!$A$1:$A$${ISO_CODES.length}`],
  });

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "planilha.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
